export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE || 'es-CO'

export const concourseId = {
  DEV: {
    'es-CO': 449,
    'es-EC': 450,
    'es-PE': 451,
    'es-BO': 452,
    'es-AR': 453,
    'es-DO': 454,
    'es-PY': 457,
  },
  PDN: {
    'es-PE': 496,
    'es-EC': 497,
    'es-AR': 498,
    'es-BO': 501,
    'es-DO': 505,
    'es-PY': 508
  },
}[ENV || 'development'][LOCALE || 'es-CO']

export const gameId = {
  DEV: {
    'es-CO': 139,
    'es-EC': 140,
    'es-PE': 141,
    'es-BO': 142,
    'es-AR': 143,
    'es-DO': 144,
    'es-PY': 145,
  },
  PDN: {
    'es-PE': 147,
    'es-EC': 148,
    'es-AR': 149,
    'es-BO': 150,
    'es-DO': 151,
    'es-PY': 152
  },
}[ENV || 'development'][LOCALE || 'es-CO']

export const costActivity = {
  'es-CO': 20,
  'es-EC': 20,
  'es-BO': 0,
  'es-PE': 20,
  'es-AR': 20,
  'es-DO': 30,
  'es-PY': 20,
}[LOCALE]

export const datesActivity = {
  'es-CO': {
    dateStartGame: '18 octubre de 2022',
    dateEndGame: '18 de noviembre de 2022',
    dateWinners: '21 de noviembre de 2022',
  },
  'es-EC': {
    dateStartGame: '31 octubre de 2022',
    dateEndGame: '30 de noviembre de 2022',
    dateWinners: '08 de diciembre de 2022',
  },
  'es-BO': {
    dateStartGame: '24 octubre de 2022',
    dateEndGame: '24 de noviembre de 2022',
    dateWinners: '01 de diciembre de 2022',
  },
  'es-PE': {
    dateStartGame: '18 octubre de 2022',
    dateEndGame: '18 de noviembre de 2022',
    dateWinners: '21 de noviembre de 2022',
  },
  'es-AR': {
    dateStartGame: '19 octubre de 2022',
    dateEndGame: '19 de noviembre de 2022',
    dateWinners: '28 de noviembre de 2022',
  },
  'es-DO': {
    dateStartGame: '27 octubre de 2022',
    dateEndGame: '27 de noviembre de 2022',
    dateWinners: '10 de diciembre de 2022',
  },
  'es-PY': {
    dateStartGame: '08 noviembre de 2022',
    dateEndGame: '08 de diciembre de 2022',
    dateWinners: '12 de diciembre de 2022',
  },
}[LOCALE]

export const topNumber = ({
  'es-CO': 10,
  'es-EC': 10,
  'es-BO': 10,
  'es-PE': 10,
  'es-DO': 10,
  'es-PY': 5

}[LOCALE] || 10)

export const costHelpActivity = 10

const videoBonusByCountry = {
  'default': "https://www.youtube.com/embed/0hv-84uRH2k",
  'es-EC': "https://www.youtube.com/watch?v=JFTFM9Q7tvQ",
  'es-AR': 'https://www.youtube.com/watch?v=JGM5-xwGZw4'
}

export const preGameUrlVideos = {
  video: [videoBonusByCountry[process.env.LOCALE] || videoBonusByCountry['default']],
}